export default "__VITE_ASSET__BrahxDpt__"